export default "__VITE_PUBLIC_ASSET__7bbef25c__"